import { Component, computed, inject, input, output } from '@angular/core';
import { WhiteLabelService } from '@crewdle/white-label/angular';
import { HubOverlayComponent } from '@crewdle/home-hub/angular';
import { AuthService } from '../../core/services/auth.service';
import { OrgContextService } from '../../core/services/org-context.service';
import { TranslateService } from '../../core/i18n/translate.service';

/**
 * Adapts Build's services to the packaged `crwd-home-hub-overlay`. Parent
 * (`app.ts`) drives [open] and handles (closed); overlay chrome + animation
 * live in `@crewdle/home-hub`.
 */
@Component({
  selector: 'app-home-hub-overlay',
  standalone: true,
  imports: [HubOverlayComponent],
  template: `
    <crwd-home-hub-overlay
      [open]="open()"
      [uid]="uid()"
      [orgId]="orgId()"
      [locale]="locale()"
      [platformName]="platformName()"
      [domainMap]="domainMap()"
      (closed)="closed.emit()"
    />
  `,
})
export class HomeHubOverlayComponent {
  readonly open = input(false);
  readonly closed = output<void>();

  private readonly auth = inject(AuthService);
  private readonly orgContext = inject(OrgContextService);
  private readonly translate = inject(TranslateService);
  private readonly whiteLabel = inject(WhiteLabelService);

  readonly uid = computed(() => this.auth.firebaseUser()?.uid ?? null);
  readonly orgId = computed(() => this.orgContext.currentOrg()?.id ?? null);
  readonly locale = this.translate.language;
  readonly platformName = computed(() => this.whiteLabel.brand()?.platformName ?? null);
  readonly domainMap = computed(() => {
    const map = this.whiteLabel.domainMap();
    return Object.keys(map).length > 0 ? map : null;
  });
}
